import { LookupDTO } from './lookup.model';

/**
 * Modello per memorizzare i dati dell'articolo
 */
export class ProductDTO {
  public ID: number;
  public Code: string;
  public Name: string;
  public MeasureUnit: string;
  public Price: number;
  public Type: Product_Type;
  public FK_Company: number;
  public DefaultAccount: LookupDTO;
  public ARaccount: LookupDTO;
  public CPaccount: LookupDTO;
  public VatRate: LookupDTO;
  public IsStamp: boolean;
  public FK_InsertUser: number;
  public InsertDate: Date;
  public FK_UpdateUser: number;
  public UpdateDate: Date;
  public IsDisabled: boolean;
  public DisabledLastChangeDate: Date;
}

export class ProductListDTO {
  public ID: number;
  public Code: string;
  public Name: string;
  public MeasureUnit: string;
  public Price: number;
  public VatRate: LookupDTO;
  public IsStamp: boolean;
  public Type: Product_Type;
  public FK_InsertUser: number;
  public InsertDate: Date;
  public FK_UpdateUser: number;
  public UpdateDate: Date;
  public IsDisabled: boolean;
  public DisabledLastChangeDate: Date;
}

export enum Product_Type {
  PRODUCT = 1,
  SERVICE = 2
}
